import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {BehaviorSubject, Observable} from 'rxjs';
import { AuthService } from 'src/app/shared/services/auth.service';

@Injectable({
    providedIn: 'root'
})
export class RepublicaMovilService {
    // Masters
    private commonRoadTypes: any;
    private roadTypes: any;
    private provinces: any;
    private provincesAmena: any;
    private countries: any;
    private serviceProviders: any;
    private documentTypes: any;
    private masterAll: any;

    // Order
    private typeOrder: any;
    private rateFtth: any;
    private rateMobiles: any[];
    private rateMobileObservable: any;
    private mobilePacks: any[];
    private mobilePacksObservable: any;
    private preventDestroyObservable: any;

    private userData: any;
    private formsData: any;

    private indexToRemove: BehaviorSubject<boolean>;

    constructor(
        private http: HttpClient,
        private auth: AuthService
    ) {
        this.rateMobiles = [];
        this.mobilePacks = [];
        this.typeOrder = new BehaviorSubject<string>('convergent');
        this.rateFtth = new BehaviorSubject<any>(null);
        this.rateMobileObservable = new BehaviorSubject<any>([]);
        this.mobilePacksObservable = new BehaviorSubject<any>([]);
        this.commonRoadTypes = new BehaviorSubject(null);
        this.roadTypes = new BehaviorSubject(null);
        this.provinces = new BehaviorSubject(null);
        this.provincesAmena = new BehaviorSubject(null);
        this.countries = new BehaviorSubject(null);
        this.serviceProviders = new BehaviorSubject(null);
        this.documentTypes = new BehaviorSubject(null);
        this.preventDestroyObservable = new BehaviorSubject(false);
        this.userData = new BehaviorSubject<any>(null);
        this.formsData = new BehaviorSubject<any>(null);
        this.indexToRemove = new BehaviorSubject<any>(null);
        this.masterAll = new BehaviorSubject(null);  
    }

    getHeaders() {
        const token = 'Bearer ' + this.auth.getToken();

        return new HttpHeaders({
            Authorization: token,
            'Content-Type': 'application/json'
        });
    }

    // Masters service
    getCommonRoadTypesFromService() {
        return this.http.get(environment.comunEndpoint + 'coverage/road-types', {headers: this.getHeaders()});
    }

    getProvincesAmenaFromService() {
        return this.http.get(environment.amenaEndpoint + 'master/provinces', {headers: this.getHeaders()});
    }

    getCitiesProvidersFromService(city: string) {
        return this.http.get(environment.rmEndpoint + 'master/cities?search=' + city, {headers: this.getHeaders()});
    }

    getMasterAllFromService() {
        return this.http.get(environment.rmEndpoint + 'master/all', {headers: this.getHeaders()});
    }

    getContract(order_id) {
        const headers = new HttpHeaders({
            Authorization: 'Bearer ' + this.auth.getToken(),
            Accept: 'application/pdf'
        });

        return this.http.get(environment.rmEndpoint + 'order/' + order_id + '/document/contract/download', {headers, responseType: 'blob'});
    }

    getSepa(order_id) {
        const headers = new HttpHeaders({
            Authorization: 'Bearer ' + this.auth.getToken(),
            Accept: 'application/pdf'
        });

        return this.http.get(environment.rmEndpoint + 'order/' + order_id + '/document/sepa/download', {headers, responseType: 'blob'});
    }

    getFileUpload(order_id, assetId) {
        const headers = new HttpHeaders({
            Authorization: 'Bearer ' + this.auth.getToken(),
            Accept: 'application/pdf'
        });

        return this.http.get(environment.rmEndpoint + 'order/' + order_id + '/document/' + assetId + '/download', {headers, responseType: 'blob'});
    }

    getOrderList() {
        return this.http.get(environment.rmEndpoint + 'order/list', {headers: this.getHeaders()});
    }

    getFilteredOrderList(filterConfig) {
        return this.http.post(environment.rmEndpoint + 'order/list/filter', filterConfig, {headers: this.getHeaders()});
    }

    getFilterAlerts(filterConfig) {
        return this.http.get(environment.rmEndpoint + 'order/list/alerts' + filterConfig, {headers: this.getHeaders()});
    }

    updateAnnotation(order_id, annotation: string) {
        const url = environment.rmEndpoint + 'order/' + order_id + '/annotation';
        const body = {annotation};

        return this.http.patch(url, body, {headers: this.getHeaders()});
    }

    uploadFile(file, orderId) {
        const formData = new FormData();
        const token = 'Bearer ' + this.auth.getToken();
        const header = new HttpHeaders({
            Authorization: token
        });

        formData.append('document', file);
        return this.http.post(environment.rmEndpoint + 'order/' + orderId + '/document/upload', formData, {headers: header});
    }

    removeOrder(id_remove) {
        const url = environment.rmEndpoint + 'order/' + `${id_remove}` + '/delete';
        return this.http.delete(url, {headers: this.getHeaders()});
    }

    // Master observers
    setCommonRoadTypes(data) {
        this.commonRoadTypes.next(data);
    }

    getCommonRoadTypes() {
        return this.commonRoadTypes.asObservable();
    }

    setRoadTypes(data) {
        this.roadTypes.next(data);
    }

    getRoadTypes() {
        return this.roadTypes.asObservable();
    }

    setProvinces(data) {
        this.provinces.next(data);
    }

    getProvinces() {
        return this.provinces.asObservable();
    }

    setProvincesAmena(data) {
        this.provincesAmena.next(data);
    }

    getProvincesAmena() {
        return this.provincesAmena.asObservable();
    }

    setCountries(data) {
        this.countries.next(data);
    }

    getCountries() {
        return this.countries.asObservable();
    }

    setServiceProviders(data) {
        this.serviceProviders.next(data);
    }

    getServiceProviders() {
        return this.serviceProviders.asObservable();
    }

    setDocumentTypes(data) {
        this.documentTypes.next(data);
    }

    getDocumentTypes() {
        return this.documentTypes.asObservable();
    }

    setMasterAll(data) {
        this.masterAll.next(data);
    }

    getMasterAll() {
        return this.masterAll.asObservable();
    }

    // Tipo de orden
    setTypeOrder(data) {
        this.typeOrder.next(data);
    }

    getTypeOrder() {
        return this.typeOrder.asObservable();
    }

    // Tarifa Fibra
    setRateFtth(data) {
        this.rateFtth.next(data);
    }

    getRateFtth() {
        return this.rateFtth.asObservable();
    }

    // Tarifa(s) móvil(es)
    setRatesMobile(index, value) {
        if (typeof this.rateMobiles[index] === 'undefined') {
            this.rateMobiles.push(value);
        } else {
            this.rateMobiles[index] = value;
        }
        this.rateMobileObservable.next(this.rateMobiles);
    }

    addFirstRatesMobile(value) {
        this.rateMobiles.unshift(value);
        this.rateMobileObservable.next(this.rateMobiles);
    }

    removeFirstRatesMobile() {
        if (this.rateMobiles.length > 0) {
            this.rateMobiles.shift();
            this.rateMobileObservable.next(this.rateMobiles);
        }
    }

    getRatesMobile() {
        return this.rateMobileObservable.asObservable();
    }

    setMobilePacks(index, value) {
        if (typeof this.mobilePacks[index] === 'undefined') {
            this.mobilePacks.push(value);
        } else {
            this.mobilePacks[index] = value;
        }

        this.mobilePacksObservable.next(this.mobilePacks);
    }

    getMobilePacks() {
        return this.mobilePacksObservable.asObservable();
    }

    getMobilePacksObject() {
        return this.mobilePacks;
    }

    setPreventDestroy(data: boolean) {
        this.preventDestroyObservable.next(data);
    }

    getPreventDestroy() {
        return this.preventDestroyObservable.asObservable();
    }

    resetMobile() {
        this.rateMobiles = [];
        this.mobilePacks = [];
        this.rateMobileObservable.next(this.rateMobiles);
        this.mobilePacksObservable.next(this.mobilePacks);
    }

    // Iniciar nueva tramitación desde otra

    setUserData(data) {
        this.userData.next(data);
    }

    getUserData() {
        return this.userData.asObservable();
    }

    setFormsData(data) {
        this.formsData.next(data);
    }

    getFormsData() {
        return this.formsData.asObservable();
    }

    removeLine(index) {
        this.rateMobiles.splice(index, 1);
        this.rateMobileObservable.next(this.rateMobiles);
        this.mobilePacks.splice(index, 1);
        this.mobilePacksObservable.next(this.mobilePacks);
    }

    getIndexToRemove() {
        return this.indexToRemove.asObservable();
    }

    setIndexToRemove(index) {
        this.indexToRemove.next(index);
        setTimeout(() => this.indexToRemove.next(null));
    }

}
